import '@rdfjs/data-model';
import '../../rdf.internal.mjs';
import { getSourceUrl } from '../../resource/resource.mjs';
import 'n3';
import '../../rdfjs.mjs';
import 'http-link-header';
import 'uuid';
import 'cross-fetch';
import { internal_getAcr } from '../control.internal.mjs';

//
/** @hidden */
const DEFAULT_ACCESS_CONTROL = "defaultAccessControl";
/** @hidden */
const DEFAULT_ACR_ACCESS_CONTROL = "defaultAcrAccessControl";
/** @hidden */
const DEFAULT_MEMBER_ACCESS_CONTROL = "defaultMemberAccessControl";
/** @hidden */
const DEFAULT_MEMBER_ACR_ACCESS_CONTROL = "defaultMemberAcrAccessControl";
/** @hidden */
function getDefaultAccessControlUrl(resource, name) {
    const acr = internal_getAcr(resource);
    const acrUrl = getSourceUrl(acr);
    return acrUrl.concat("#").concat(name);
}

export { DEFAULT_ACCESS_CONTROL, DEFAULT_ACR_ACCESS_CONTROL, DEFAULT_MEMBER_ACCESS_CONTROL, DEFAULT_MEMBER_ACR_ACCESS_CONTROL, getDefaultAccessControlUrl };
